import React, { useState, useCallback, useEffect, useRef } from 'react'
import { Formik, Form, Field } from 'formik'
import { useModal } from 'react-modal-hook'
import { useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import NumberFormat from 'react-number-format'
import { NeoLoader, NeoOTP, NeoSuccess } from '../../../components/FormComponents'
import NeoButton from '../../../components/NeoButton/NeoButton'
import NeoInput from '../../../components/NeoInput/NeoInput'
import InputError from '../../../components/InputError/InputError'
import Loading from 'custom/assets/loaders/Loading'

import Modal from '../../../components/Modal/Modal'
import BeneficiaryDisplay from '../../../components/beneficiary-display/beneficiary-display'
import BeneIcon from 'custom/assets/common-icons/bene-image.svg'
import DeleteIcon from 'custom/assets/icons/delete.svg'
import UploadIcon from 'custom/assets/icons/upload.svg'
import BeneficiaryService from '../../../services/beneficiary.service'
import LayoutWithAccountCard from '../../Layout/layout-account-card'
import { EditOtherBeneficiarySchema } from '../../../schemas/transfers'
import { BUTTON_KEYS, EDIT_BENEFICIARY_KEYS } from '../../../utils/translation-constants'
import validationConfig from 'custom/config/validation.config.json'
const editDomesticConfig = validationConfig['editBeneficiary']['domestic']
import Config from 'custom/config/environment'

export default function EditDomesticBeneficiary() {
  const history = useHistory()
  const location = useLocation()
  const [stage, setStage] = useState(0)
  const [otpEnabled, setOtpEnabled] = useState(false)
  const [formValues, setFormValues] = useState({})
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const [otp, setOtp] = useState('')
  const [verifiedBeneDetails, setVerifiedBeneDetails] = useState({})
  const [beneDetails, setBeneDetails] = useState({})
  const [imageLocation, setImageLocation] = useState('')
  const [deleteImageLoading, setDeleteImageLoading] = useState(false)
  const [updateImageLoading, setUpdateImageLoading] = useState(false)
  const beneImage = useRef(null)
  const { t } = useTranslation()

  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6 className='text-center'>{message}</h6>
          <div className='modal-btn-style'>
            <NeoButton
              tabIndex='1'
              mode='newDesign'
              type='button'
              text={t(BUTTON_KEYS.OK)}
              onClick={() => {
                hideModal()
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [message],
  )

  const [showSuccessModal, hideSuccessModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6 className='text-center'>{message}</h6>
          <div className='modal-btn-style'>
            <NeoButton
              tabIndex='1'
              mode='newDesign'
              type='button'
              text={t(BUTTON_KEYS.OK)}
              onClick={() => {
                hideSuccessModal()
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [message],
  )

  useEffect(() => {
    if (location.state === undefined) {
      history.push('/transfers/beneficiary-view')
      return
    }
    console.log(location?.state)
    setBeneDetails(location?.state?.beneDetails)
  }, [])

  const handleFileRead = useCallback(
    async (e) => {
      const content = e.target.result
      await updateImage(content.toString().split(',')[1], beneDetails)
    },
    [beneDetails],
  )

  useEffect(() => {
    const fileReader = new FileReader()
    fileReader.onloadend = handleFileRead
    if (imageLocation !== '') {
      fileReader.readAsDataURL(imageLocation)
    }
  }, [imageLocation, handleFileRead])

  const deleteImage = useCallback(async () => {
    setDeleteImageLoading(true)
    try {
      const response = await BeneficiaryService.removeBeneficiaryImage({
        accountNo: beneDetails.beneAccNo,
      })
      if (response.status === 200) {
        setMessage(response.data.message)
        setStage(4)
        setDeleteImageLoading(false)
        // beneDetails.image = null
      }
    } catch (err) {
      setMessage(err.data.message)
      setDeleteImageLoading(false)
      //showModal()
    }
  }, [showModal, beneDetails])

  const updateImage = useCallback(
    async (imageData, beneDetails) => {
      setUpdateImageLoading(true)
      try {
        const response = await BeneficiaryService.updateBeneImage({
          accountNo: beneDetails.beneAccNo,
          imageData: imageData,
        })
        if (response.status === 200) {
          beneDetails.image = imageData
          setMessage(response.data.message)
          setStage(4)
          setUpdateImageLoading(false)
          // //showModal()
        }
      } catch (err) {
        // if (imageData.length > 100) {
        //   setMessage('Image Size too large. Please Upload images less than 100Kb')
        // }
        setUpdateImageLoading(false)
        // showSuccessModal()
      }
    },
    [showModal],
  )

  const onVerify = useCallback(
    async (data) => {
      try {
        if (data.transferAmount < Config.MIN_TRANSFER_LIMIT) {
          return
        }
        setFormValues(data)
        setLoading(true)
        const response = await BeneficiaryService.modifyDomesticBeneVerifyVerify({
          shortName: data?.nickName,
          beneAccNo: beneDetails?.beneAccNo,
          isVisibleToGroup: beneDetails?.isVisibleToGroup,
          maxTransferLimit: data?.maxTransferAmount?.replace(/\,/g, ''),
          beneMobileNo: data.beneMobileNo,
          beneEmail: data.beneEmail,
          sortCode: beneDetails?.sortCode,
        })
        if (response.status === 200) {
          setOtpEnabled(response.data['otpEnable'])
          setVerifiedBeneDetails(response.data)
          setStage(2)
          setLoading(false)
        }
      } catch (err) {
        setLoading(false)
        setMessage(err.data.message)
        //showModal()
      }
    },
    [showModal, beneDetails],
  )
  const onConfirm = useCallback(async () => {
    try {
      setLoading(true)
      const response = await BeneficiaryService.modifyDomesticBeneVerifyConfirm({
        shortName: formValues?.nickName,
        beneAccNo: beneDetails?.beneAccNo,
        isVisibleToGroup: beneDetails?.isVisibleToGroup,
        maxTransferLimit: formValues?.maxTransferAmount?.replace(/\,/g, ''),
        beneMobileNo: formValues.beneMobileNo,
        beneEmail: formValues.beneEmail,
        sortCode: beneDetails?.sortCode,
        otp: otp,
        randomKey: verifiedBeneDetails?.randomKey,
      })
      if (response.status === 200) {
        setMessage(response.data['message'])
        setLoading(false)
        setStage(4)
      }
    } catch (err) {
      setLoading(false)
      setMessage(err.data.message)
      setOtp('')
      //showModal()
    }
  }, [formValues, otp, beneDetails, verifiedBeneDetails])

  const verifyRemoveBeneficiary = useCallback(
    async (data) => {
      try {
        setLoading(true)
        const response = await BeneficiaryService.removeInitBeneVerify({
          reqId: beneDetails?.reqId,
          internalBene: false,
          beneAccNo: beneDetails?.beneAccNo,
        })
        if (response.status === 200) {
          setOtpEnabled(response.data['otpEnable'])
          setVerifiedBeneDetails(response.data)
          setStage(5)
          setLoading(false)
        }
      } catch (err) {
        setLoading(false)
        setMessage(err.data.message)
        //showModal()
      }
    },
    [showModal, beneDetails],
  )

  const onRemoveConfirm = useCallback(async () => {
    try {
      setLoading(true)
      const response = await BeneficiaryService.removeInitBeneConfirm({
        reqId: beneDetails?.reqId,
        internalBene: false,
        beneAccNo: beneDetails?.beneAccNo,
        otp: otp || '0000',
        randomKey: verifiedBeneDetails?.randomKey,
      })
      if (response.status === 200) {
        setMessage(response.data['message'])
        setLoading(false)
        setStage(4)
      }
    } catch (err) {
      setLoading(false)
      setMessage(err.data.message)
      setOtp('')
      //showModal()
    }
  }, [showModal, beneDetails, otp])

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderBeneDetails()
      case 1:
        return renderForm()
      case 2:
        return renderConfirmation()
      case 3:
        return <NeoOTP otp={otp} setOTP={setOtp} onSubmit={onConfirm} loading={loading} />

      case 4:
        return <NeoSuccess message={message} linkPath='/transfers/beneficiary-view' />
      case 5:
        return <NeoOTP otp={otp} setOTP={setOtp} onSubmit={onRemoveConfirm} loading={loading} />
      default:
        return renderForm()
    }
  }

  function renderForm() {
    return (
      <div>
        <Formik
          initialValues={{
            nickName: beneDetails?.shortName,
            accountNumber: beneDetails?.beneAccNo,
            transferAmount: beneDetails?.maxTransferLimit,
            maxTransferAmount: '' + beneDetails?.maxTransferLimit,
            beneMobileNo: beneDetails?.beneMobileNo,
            beneEmail: beneDetails?.beneEmail,
          }}
          enableReinitialize
          validationSchema={EditOtherBeneficiarySchema}
          onSubmit={onVerify}>
          {({ isSubmitting, errors, touched, handleChange, values, setFieldValue }) => (
            <Form>
              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='1'
                    showAsterisk={editDomesticConfig['isNickNameRequired']}
                    text={t(EDIT_BENEFICIARY_KEYS.NICK_NAME)}
                    name='nickName'
                    value={values.nickName}
                    onChange={handleChange}
                    minLength={2}
                    maxLength={20}
                    onKeyPress={(event) => {
                      if (
                        !(event.charCode >= 65 && event.charCode <= 90) &&
                        !(event.charCode >= 97 && event.charCode <= 122) &&
                        event.charCode !== 32
                      ) {
                        event.preventDefault()
                      }
                    }}
                  />
                  <InputError
                    text={errors.nickName}
                    onChange={handleChange}
                    touched={touched.nickName}
                  />
                </div>

                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='2'
                    showAsterisk={editDomesticConfig['isEmailRequired']}
                    text={t(EDIT_BENEFICIARY_KEYS.BENE_EMAIL_ID)}
                    name='beneEmail'
                    value={values.beneEmail}
                    onChange={handleChange}
                  />
                  <InputError text={errors.beneEmail} touched={touched.beneEmail} />
                </div>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='3'
                    showAsterisk={editDomesticConfig['isMobileNoRequired']}
                    text={t(EDIT_BENEFICIARY_KEYS.BENE_MOBILE_NO)}
                    onChange={(value) => {
                      setFieldValue('beneMobileNo', value?.value)
                    }}
                    mode='onlyNumber'
                    name='beneMobileNo'
                    value={values.beneMobileNo}
                    minLength={8}
                    maxLength={15}
                  />
                  <InputError text={errors.beneMobileNo} touched={touched.beneMobileNo} />
                </div>

                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='4'
                    text={t(EDIT_BENEFICIARY_KEYS.TRANSFER_LIMIT)}
                    type='number'
                    mode='amount'
                    value={values.maxTransferAmount}
                    onChange={(value) => {
                      setFieldValue('transferAmount', value?.floatValue)
                      setFieldValue('maxTransferAmount', value?.value)
                    }}
                    name='maxTransferAmount'
                  />
                  <InputError text={errors.maxTransferAmount} touched={touched.maxTransferAmount} />
                  <InputError
                    text={`${t(EDIT_BENEFICIARY_KEYS.TRANSFER_LIMIT_TXT)} ${
                      Config.MIN_TRANSFER_LIMIT
                    }.00`}
                    touched={values.transferAmount < Config.MIN_TRANSFER_LIMIT}
                  />
                </div>
              </div>

              <div className='mt-3'>
                {loading ? (
                  renderLoading()
                ) : (
                  <NeoButton
                    tabIndex='5'
                    type='submit'
                    text={t(BUTTON_KEYS.SUBMIT)}
                    disabled={isSubmitting}
                    mode='newDesign'
                  />
                )}
              </div>
              <div className='back-cancel-btn-container'>
                <button
                  tabIndex={'6'}
                  className='back-cancel-btn btn btn-sm new-design-warning-text-color'
                  onClick={() => setStage(0)}>
                  {' '}
                  {t(BUTTON_KEYS.BACK)}{' '}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderBeneDetails() {
    return (
      <>
        <div className='row'>
          <div className='col-6'>
            <NeoButton
              tabIndex='1'
              type='button'
              mode='newDesign'
              className='btn btn-neo'
              onClick={() => setStage(1)}
              text={t(BUTTON_KEYS.MODIFY_BENEFICIARY)}
            />
          </div>
          <div className='col-6'>
            {loading ? (
              renderLoading()
            ) : (
              <NeoButton
                tabIndex='2'
                type='button'
                mode='newDesign'
                className='btn btn-neo'
                onClick={() => verifyRemoveBeneficiary()}
                text={t(BUTTON_KEYS.DELETE_BENEFICIARY)}
              />
            )}
          </div>
        </div>

        <div className='back-cancel-btn-container'>
          <button
            tabIndex={'3'}
            className='back-cancel-btn btn btn-sm new-design-warning-text-color'
            onClick={() => history.goBack()}>
            {t(BUTTON_KEYS.CANCEL)}{' '}
          </button>
        </div>
      </>
    )
  }

  function renderConfirmation() {
    return (
      <div className='d-flex flex-column confirmation'>
        <div>
          <h6 className='label'>{t(EDIT_BENEFICIARY_KEYS.SHORT_NAME)}</h6>
          <h6 className='value'>{formValues.nickName}</h6>
        </div>

        <div>
          <h6 className='label'>{t(EDIT_BENEFICIARY_KEYS.MAX_TRANSFER_AMOUNT)}</h6>
          <h6 className='value'>
            <NumberFormat
              value={formValues?.maxTransferAmount}
              displayType={'text'}
              thousandSeparator={true}
              prefix={''}
              fixedDecimalScale={true}
              decimalScale={2}
              allowEmptyFormatting
            />
          </h6>
        </div>

        <div>
          <h6 className='label'>{t(EDIT_BENEFICIARY_KEYS.BENE_EMAIL_ID)}</h6>
          <h6 className='value'>{formValues.beneEmail}</h6>
        </div>

        <div>
          <h6 className='label'>{t(EDIT_BENEFICIARY_KEYS.BENE_MOBILE_NO)}</h6>
          <h6 className='value'>{formValues.beneMobileNo}</h6>
        </div>

        <div className='mt-3'>
          {loading ? (
            renderLoading()
          ) : (
            <NeoButton
              type='button'
              mode='newDesign'
              className='btn btn-neo'
              onClick={() => (otpEnabled ? setStage(3) : onConfirm())}
              text={t(BUTTON_KEYS.CONFIRM)}
            />
          )}
        </div>
        <div className='back-cancel-style' onClick={() => setStage(1)}>
          {t(BUTTON_KEYS.BACK)}{' '}
        </div>
      </div>
    )
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  return (
    <LayoutWithAccountCard breadCumKey='BENE_DOMESTIC_MODIFY'>
      <div className='new-design-form-style'>
        <div className='heading-style'>{t(EDIT_BENEFICIARY_KEYS.DOMESTIC_BENE_HEADER)}</div>
        {stage !== 3 && stage !== 4 && stage !== 5 && (
          <>
            <div className='bene-modify-details'>
              <img
                className='bene-image'
                src={beneDetails?.image === null ? BeneIcon : beneDetails?.image}
                width={160}
                height={160}
              />
              {stage == 0 && (
                <>
                  {deleteImageLoading ? (
                    <NeoLoader />
                  ) : (
                    <>
                      {beneDetails?.image !== null && (
                        <img
                          onClick={() => deleteImage()}
                          src={DeleteIcon}
                          className='delete-image'
                        />
                      )}
                    </>
                  )}
                </>
              )}
              {stage == 0 && (
                <>
                  {updateImageLoading ? (
                    <NeoLoader />
                  ) : (
                    <button
                      style={{ margin: '0 auto' }}
                      type='button'
                      ref={beneImage}
                      onClick={() => {
                        beneImage.current.click()
                      }}
                      className=' d-flex btn btn-sm btn-link small new-design-warning-text-color font-weight-600'>
                      <img src={UploadIcon} className='mr-2' />
                      {t(EDIT_BENEFICIARY_KEYS.MODIFY_BENE_IMAGE)}
                    </button>
                  )}
                  <input
                    type='file'
                    id='file'
                    accept='image/png, image/jpeg, image/jpg'
                    ref={beneImage}
                    style={{ display: 'none' }}
                    onChange={(e) => {
                      var size = e.target.files[0].size / 1000
                      if (size > 100) {
                        setMessage('Image Size too large. Please Upload images less than 100Kb')
                        e.target.value = null
                        showModal()
                        return
                      }
                      setImageLocation(e.target.files[0])
                    }}
                  />
                </>
              )}
            </div>

            <div className='d-flex flex-column confirmation'>
              <div>
                <h6 className='label'>{t(EDIT_BENEFICIARY_KEYS.BENEFICIARY_NAME)}</h6>
                <h6 className='value'>{beneDetails?.beneName}</h6>
              </div>
              <div>
                <h6 className='label'>{t(EDIT_BENEFICIARY_KEYS.ACCOUNT_NUMBER)}</h6>
                <h6 className='value'>{beneDetails?.beneAccNo}</h6>
              </div>

              {stage == 0 && (
                <div>
                  <h6 className='label'>{t(EDIT_BENEFICIARY_KEYS.SHORT_NAME)}</h6>
                  <h6 className='value'>{beneDetails?.shortName}</h6>
                </div>
              )}

              {stage == 0 && (
                <div>
                  <h6 className='label'>{t(EDIT_BENEFICIARY_KEYS.TRANSFER_LIMIT)}</h6>
                  <h6 className='value'>
                    <NumberFormat
                      value={beneDetails?.maxTransferLimit}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={''}
                      fixedDecimalScale={true}
                      decimalScale={2}
                      allowEmptyFormatting
                    />
                  </h6>
                </div>
              )}
            </div>
          </>
        )}

        {renderSwitch()}
      </div>
    </LayoutWithAccountCard>
  )
}
